import { buildQueryKey } from '@webapp/core/utils/react-query/buildQueryKey'
import {
  type ListCreditCardItemsParams,
  type ListUnmatchedCreditCardItemsParams,
} from '@webapp/modules/accounts-payable/business-logic/interfaces/ICreditCardItemRepository'
import { creditCardItemRepository } from '../data-access/repositories/CreditCardItemRepository'

const base = ['credit-card-items']

// Partial keys for command invalidation (item create/edit/archive/move,
// match commands, statement import).
export const CREDIT_CARD_ITEM_LIST_BASE_KEY = [...base, 'list']
export const CREDIT_CARD_ITEM_UNMATCHED_BASE_KEY = [...base, 'unmatched']

export const creditCardItemQueries = {
  list: (params: ListCreditCardItemsParams) => ({
    queryKey: buildQueryKey([...CREDIT_CARD_ITEM_LIST_BASE_KEY, params]),
    queryFn: () => creditCardItemRepository.list(params),
  }),
  unmatched: (params: ListUnmatchedCreditCardItemsParams) => ({
    queryKey: buildQueryKey([...CREDIT_CARD_ITEM_UNMATCHED_BASE_KEY, params]),
    queryFn: () => creditCardItemRepository.listUnmatched(params),
  }),
}
